import { c as _c } from "react/compiler-runtime";
import { useRequestErrorToast } from '@onefootprint/hooks';
import request from '@onefootprint/request';
import type { UserUpdateRequest, UserUpdateResponse } from '@onefootprint/types';
import { useMutation } from '@tanstack/react-query';
import type { AuthHeaders } from '../use-session';
import useSession from '../use-session';
const updateUser = async (authHeaders: AuthHeaders, data: UserUpdateRequest) => {
  const response = await request<UserUpdateResponse>({
    data,
    headers: authHeaders,
    method: 'PATCH',
    url: '/org/member'
  });
  return response.data;
};
const useUserSession = () => {
  const $ = _c(10);
  const showErrorToast = useRequestErrorToast();
  const session = useSession();
  const data = session.data?.user;
  const dangerouslyCastedData = session.dangerouslyCastedData.user;
  let t0;
  if ($[0] !== session.authHeaders) {
    t0 = payload => updateUser(session.authHeaders, payload);
    $[0] = session.authHeaders;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== session.updateUserName || $[3] !== showErrorToast || $[4] !== t0) {
    t1 = {
      mutationFn: t0,
      onSuccess: session.updateUserName,
      onError: showErrorToast
    };
    $[2] = session.updateUserName;
    $[3] = showErrorToast;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const mutation = useMutation(t1);
  let t2;
  if ($[6] !== dangerouslyCastedData || $[7] !== data || $[8] !== mutation) {
    t2 = {
      dangerouslyCastedData,
      data,
      mutation
    };
    $[6] = dangerouslyCastedData;
    $[7] = data;
    $[8] = mutation;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default useUserSession;